<template>
	<div class="tab-body">
		<div class="search">
			<el-form ref="form" :model="searchParams" label-width="80px">
				<el-row>
					<el-col :span="6">
						<el-form-item label="姓名">
							<el-input v-model="searchParams.name"></el-input>
						</el-form-item>
					</el-col>
					
	<el-col :span="6">
						<el-form-item label="跟进人">
							<el-input v-model="searchParams.rname"></el-input>
						</el-form-item>
					</el-col>
					<el-collapse-transition>
						<div v-if="isShowMoreSearch">
							<!--隐藏区域-->
						</div>
					</el-collapse-transition>
					<div class="search-btn">
						<el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
						<el-button @click="clearSearchVal">清空</el-button>

					</div>
				</el-row>
			</el-form>
		</div>
		<div class="operator">
			<!-- <el-button type="primary" icon="el-icon-plus" @click="toSave()">添加</el-button> -->
			<!-- <el-button type="danger" icon="el-icon-delete" @click="batchRemove()">批量删除</el-button> -->
		</div>
		<div class="dataTable autoFlex" v-if="listData">
			<el-table class="table" :data="listData.records" stripe border height="auto" @selection-change="selectionChange"
				v-loading="listLoading">
				<el-table-column type="selection" width="55" fixed="left"></el-table-column>
				<el-table-column prop="gnneedtm" label="计划跟进时间"></el-table-column>
				<el-table-column prop="gntm" label="跟进时间"></el-table-column>
				<el-table-column prop="snm" label="被跟进人"></el-table-column>
				<el-table-column prop="username" label="跟进人"></el-table-column>
				<!-- <el-table-column prop="cost" label="金额"></el-table-column> -->
				<el-table-column prop="type" label="跟进类型"></el-table-column>

				<!-- <el-table-column prop="message" label="推送前端的消息"></el-table-column> -->
				<!-- <el-table-column prop="msgtm" label="消息接受时间"></el-table-column> -->
				<el-table-column prop="result" label="跟进状态"></el-table-column>

				<el-table-column label="操作" fixed="right" width="260px">
					<template slot-scope="scope">
						<div class="dataTable-operator">
							<el-button size="mini"   @click="toDetail( scope.row )">查看/跟进</el-button>
							<el-button size="mini"   type="danger" @click="remove(scope.$index, scope.row)">删除</el-button> 
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pageBar">
				<el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
					:page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
					:page-sizes="this.$constant.page.pageSizes"></el-pagination>
			</div>
		</div>
		<edit ref="edit"></edit>
	</div>
</template>
<script>
import edit from './edit.vue';
import api from '@/api/xueli/xlsturecord.js';
export default {
	name: 'xlsturecord',
	components: {
		edit
	},
	data() {
		return {
			searchParams: {},
			isShowMoreSearch: false,
			listLoading: false,
			listData: [],
			selected: [],
			page: new this.$constant.pageObj(),
		};
	},
	methods: {
		//获取数据
		list() {
			this.listLoading = true;
			let params = this.$utils.merger(this.searchParams, this.page);
			api.list(params, response => {
				this.listData = response.data;
				this.listLoading = false;
				console.log('	this.listData', response.data);
			})
		},
		//去添加
		// toSave(index, row) {
		// 	// let editParameter = {
		// 	// 	id: row.id,
		// 	// };
		// 	this.$refs.edit.open({}, '添加');
		// },
		//去编辑
		toUpdate(index, row) {
			console.log('row', row);
			let editParameter = {
				stuid: row.stuid,
				type: row.type
			};
			this.$refs.edit.open(editParameter, '编辑');
		},
		//去详情
		toDetail(  row) {

			this.$refs.edit.open(row, '查看跟进详情', true);
  
 
		},
		//删除
		remove(index, row) {
			let parameter = {
				ids: row.id
			}
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove(
					parameter,
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//批量删除
		batchRemove() {
			if (!this.selected || this.selected.length == 0) {
				this.$utils.msg.info('请选择至少一行');
				return;
			}
			let parameter = {
				ids: this.selected
			};
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove({
					ids: this.selected
				},
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//改变选择项
		selectionChange(val) {
			//清空
			this.selected = [];
			for (let item of val) {
				this.selected.push(item.id);
			}
		},
		//改变每页显示数量
		sizeChange(val) {
			this.page.size = val;
			this.list();
		},
		//改变现在的页码
		currentChange(val) {
			this.page.current = val;
			this.list();
		},

		//搜索
		search() {
			this.list();
		},
		//清空搜索框
		clearSearchVal() {
			this.searchParams = {};
		}
	},
	mounted() {
		this.list();
		console.log('	this.listData', this.listData);
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
</style>

